<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const value = computed(() => {
  if(typeof props.data != 'object' || Object.keys(props.data).length === 0 ) return
  return props.data
})
</script>

<template>
  <div class="table-cell address-cell">
    <div class="region whitespace-nowrap">{{ props.data?.region }}</div>
    <div class="address">{{ props.data?.address }}</div>
  </div>
</template>

<style scoped>

</style>
